import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          deletion: {
            '{}': {
              ids: {
                '[]': [
                  {
                    '@$': 'termId',
                  },
                ],
              },
              modelId: 'ent:!subaward_tcs:!tc',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
